import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PfeUtilService } from '../pfe-util/services/util.service';

@Injectable()
export class PfeHeaderInterceptor implements HttpInterceptor {
  constructor(private pfeUtilService: PfeUtilService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        // Add the tenant and applicationId only if they are defined
        //(Yes, a bit harder to read than a simple if, but that's why this comment is here ;-))
        ...(this.pfeUtilService.tenant && { tenant: this.pfeUtilService.tenant }),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ...(this.pfeUtilService.applicationId && { 'config-id': this.pfeUtilService.applicationId }),
      },
    });
    return next.handle(req);
  }
}
